import { render, staticRenderFns } from "./FiatTransactionDetail.vue?vue&type=template&id=1bb265e3&"
import script from "./FiatTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./FiatTransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./FiatTransactionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports